/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConnectedAccount } from './ConnectedAccount';
import {
    ConnectedAccountFromJSON,
    ConnectedAccountFromJSONTyped,
    ConnectedAccountToJSON,
    ConnectedAccountToJSONTyped,
} from './ConnectedAccount';

/**
 *
 * @export
 * @interface ConnectedAccounts
 */
export interface ConnectedAccounts {
    /**
     *
     * @type {Array<ConnectedAccount>}
     * @memberof ConnectedAccounts
     */
    readonly socialAccounts: Array<ConnectedAccount>;
    /**
     *
     * @type {boolean}
     * @memberof ConnectedAccounts
     */
    readonly hasUsablePassword: boolean;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccounts
     */
    readonly manageUrl: string;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccounts
     */
    readonly setPasswordUrl: string;
}

/**
 * Check if a given object implements the ConnectedAccounts interface.
 */
export function instanceOfConnectedAccounts(value: object): value is ConnectedAccounts {
    if (!('socialAccounts' in value) || value['socialAccounts'] === undefined) return false;
    if (!('hasUsablePassword' in value) || value['hasUsablePassword'] === undefined) return false;
    if (!('manageUrl' in value) || value['manageUrl'] === undefined) return false;
    if (!('setPasswordUrl' in value) || value['setPasswordUrl'] === undefined) return false;
    return true;
}

export function ConnectedAccountsFromJSON(json: any): ConnectedAccounts {
    return ConnectedAccountsFromJSONTyped(json, false);
}

export function ConnectedAccountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectedAccounts {
    if (json == null) {
        return json;
    }
    return {

        'socialAccounts': ((json['social_accounts'] as Array<any>).map(ConnectedAccountFromJSON)),
        'hasUsablePassword': json['has_usable_password'],
        'manageUrl': json['manage_url'],
        'setPasswordUrl': json['set_password_url'],
    };
}

  export function ConnectedAccountsToJSON(json: any): ConnectedAccounts {
      return ConnectedAccountsToJSONTyped(json, false);
  }

  export function ConnectedAccountsToJSONTyped(value?: Omit<ConnectedAccounts, 'social_accounts'|'has_usable_password'|'manage_url'|'set_password_url'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
